const commonPresets = {
    axios: { workerRef: 'module.exports = window.w.utils.axios' },
    lodash: { workerRef: 'module.exports = window.w.utils.lodash' },
    dayjs: { workerRef: 'module.exports = window.w.utils.dayjs' },
    crypto: { workerRef: 'module.exports = window.w.utils.crypto' },
    'crypto-js': { workerRef: 'module.exports = window.w.utils.crypto' },
    ajv: { workerRef: 'module.exports = window.w.utils.ajv' },
    Buffer: { workerRef: 'module.exports = window.w.utils.Buffer' },
    qs: { workerRef: 'module.exports = window.w.utils.qs' },
    'js-yaml': {},
    marked: {},
    pako: {},
    '@wujibase/wuji': {},
    '@wujibase/wuji-flow': {},
    '@wujibase/wuji-flow/vue': {},
    '@wujibase/wuji-upload': {},
    '@wujibase/wuji-data': {},
};
const vue3Presets = {
    vue: { workerRef: 'module.exports = (window.vue3 || window.Vue3).Vue3' },
    'vue-router': { workerRef: 'module.exports = (window.vue3 || window.Vue3).vueRouter' },
    'ant-design-vue': { workerRef: 'module.exports = (window.vue3 || window.Vue3).antd' },
    'tdesign-vue-next': {},
};
const reactPresets = {
    react: { workerRef: 'module.exports = window.React' },
    'react-dom': { workerRef: 'module.exports = window.ReactDOM' },
    'react-dom/client': { workerRef: 'module.exports = window.ReactDOMClient' },
    'react-router': { workerRef: 'module.exports = window.ReactRouterDOM' },
    'react-router-dom': { workerRef: 'module.exports = window.ReactRouterDOM' },
    'react/jsx-runtime': { workerRef: 'module.exports = window.ReactJSXRuntime' },
    'react/jsx-dev-runtime': { workerRef: 'module.exports = window.ReactJSXDevRuntime' },
    zustand: { workerRef: 'module.exports = window.Zustand' },
    'zustand/shallow': { workerRef: 'module.exports = window.ZustandShallow' },
};
function getFrameworkPresets(framework) {
    return framework === 'react' ? reactPresets : vue3Presets;
}
export function getPresetNames(framework) {
    return [
        ...Object.keys(commonPresets),
        ...Object.keys(getFrameworkPresets(framework)),
    ];
}
export function getWorkerPresets(framework) {
    const all = { ...commonPresets, ...getFrameworkPresets(framework) };
    const result = {};
    for (const [name, entry] of Object.entries(all)) {
        if (entry.workerRef) {
            result[name] = entry.workerRef;
        }
    }
    return result;
}
export function getAllPresetNames(framework = 'vue3') {
    const all = { ...commonPresets, ...getFrameworkPresets(framework) };
    return Object.keys(all);
}
